import { Box, Dialog, Divider, Slide, Typography } from '@mui/material';
import { IconPC } from 'components/MenuMakeImport/Stepper/Icons';
import { StepperStart } from 'components/MenuMakeImport/Stepper/StepperStart';
import { StepperStartText } from 'components/MenuMakeImport/Stepper/StepperStartText';
import { StepperStartTitle } from 'components/MenuMakeImport/Stepper/StepperStartTitle';
import { StepperStartContentDialog } from 'components/MenuMakeImport/Stepper/StepperStartContentDialog';
import { StepperDialogEndContent } from 'components/MenuMakeImport/StepperDialogEndContent';
import useStyles from 'components/MenuMakeImport/styles';
import { useTranslation } from 'react-i18next';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide ref={ref} direction="up" {...props} />;
// });
import styled from '@emotion/styled';

const StyledLink = styled('a')({
  textDecoration: 'underline',
  color: '#44AEC9',
});

const ListStyled = styled('ol')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  counterReset: 'list-counter',

  '& li': {
    counterIncrement: 'list-counter',
    position: 'relative',
    paddingLeft: '2rem',
    marginBottom: '1.5rem',

    '&::before': {
      content: 'counter(list-counter)',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1.5rem',
      height: '1.5rem',
      backgroundColor: 'black',
      color: 'white',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
  },
});

export const SummaryDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Dialog fullScreen open={open}>
      <Box className={classes.rootStepper}>
        <StepperStartContentDialog variant="white">
          <StepperStart>
            <IconPC />
            <StepperStartTitle sx={{ fontSize: '40px' }}>{t('menuMaker:importMenu.summary.title')}</StepperStartTitle>
            <StepperStartText sx={{ mb: 2 }}>{t('menuMaker:importMenu.summary.description')}</StepperStartText>
          </StepperStart>
        </StepperStartContentDialog>

        <StepperDialogEndContent hideIconClose labelButtonNext={t('common:buttons.close')} onNext={onClose}>
          <Box>
            <Typography sx={{ mb: 2 }} variant="h6">
              {t('menuMaker:importMenu.summary.listA.title')}
            </Typography>
            <ListStyled>
              <li>
                <Typography variant="body1">{t('menuMaker:importMenu.summary.listA.1')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('menuMaker:importMenu.summary.listA.2')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('menuMaker:importMenu.summary.listA.3')}</Typography>
              </li>
            </ListStyled>
            <StyledLink
              href="https://soporte.parrotsoftware.com.mx/es_MX/configurar-menu/copia-de-menus"
              target="_blank"
            >
              <Typography variant="body1">{t('menuMaker:importMenu.summary.listA.link')}</Typography>
            </StyledLink>
            <Divider sx={{ my: 4 }} />
            <Typography sx={{ mb: 2 }} variant="h6">
              {t('menuMaker:importMenu.summary.listB.title')}
            </Typography>

            <ListStyled>
              <li>
                <Typography variant="body1">{t('menuMaker:importMenu.summary.listB.1')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('menuMaker:importMenu.summary.listB.2')}</Typography>
              </li>
              <li>
                <Typography variant="body1">{t('menuMaker:importMenu.summary.listB.3')}</Typography>
              </li>
            </ListStyled>
            <StyledLink
              href="https://soporte.parrotsoftware.com.mx/es_MX/configurar-menu/edicion-de-articulos-por-menu"
              target="_blank"
            >
              <Typography variant="body1">{t('menuMaker:importMenu.summary.listB.link')}</Typography>
            </StyledLink>
          </Box>
        </StepperDialogEndContent>
      </Box>
    </Dialog>
  );
};
